import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

@connect((store) => {
    return { 
        isKaiserMember: store.user.isKaiserMember,
        date: store.meta.date.getDay()
    };
})
class Huckleberry extends React.Component {
    constructor(props) {
        super(props);
        this.goToHuckleberryInfo = this.goToHuckleberryInfo.bind(this);
        this.goToFpact = this.goToFpact.bind(this);
    }

    goToHuckleberryInfo() {
        this.props.history.push('/location?id=huckleberry');
    }

    goToFpact() {
        this.props.history.push('/fpact');
    }

    render() {
        console.log('the date is ' + this.props.date);

        let topText = null;
        let bottomText = null;

        let testDate = 2;

        // switch(testDate) {
        switch(this.props.date) {
            case 0: //sun
                console.log('it is Sunday');
                topText = 'Tuesday is Huckleberry’s Teen Tuesday Clinic from 4PM. You can also get EC for free there.';
                bottomText = 'Are you able to wait and make it to San Rafael on Tuesday?';
                break;
            case 1: //mon
                console.log('it is Monday');
                topText = 'Tomorrow is Huckleberry’s Teen Tuesday Clinic from 4PM. You can also get EC for free there.';
                bottomText = 'Are you able to wait and make it to San Rafael tomorrow?';
                break;
            default:
                console.log('navigate to fpact');
        }

        return (
            <div>
                <div className="row justify-content-md-center">
                    <div className="col-md-6">
                        <p className="ec__font__body text-center">
                            {topText}
                        </p>

                        <h1 className="ec__font__title text-center">
                            {bottomText}
                        </h1>

                        <p className="ec__font__body text-center ec__font__body--small">
                            You can get a confidential pass from school, if needed.
                        </p>
                    </div>
                </div>

                <div className="choices choices--small row">
                    <div className="col text-center">
                        <button className="ec__button" onClick={this.goToHuckleberryInfo}>Yes</button>
                    </div>
                    <div className="col text-center">
                        <button className="ec__button" onClick={this.goToFpact}>No</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default Huckleberry;


// WEBPACK FOOTER //
// ./src/components/screens/Huckleberry.js